var Const = /** @class */ (function () {
    function Const() {
    }
    // =================IP ADDRESS============================
    Const.RUN_GET_IP_ADDRESS_LIST = '/RUN_GET_IP_ADDRESS_LIST';
    Const.GET_IP_ADDRESS_LIST = '/GET_IP_ADDRESS_LIST';
    Const.SET_IP_ADDRESS_LIST = '/SET_IP_ADDRESS_LIST';
    Const.RUN_ADD_IP_ADDRES = '/RUN_ADD_IP_ADDRES';
    Const.RUN_UPDATE_IP_ADDRES = '/RUN_UPDATE_IP_ADDRES';
    // ======================= Login Info =========================
    Const.RUN_GET_LOGIN_INFO = '/RUN_GET_LOGIN_INFO';
    Const.GET_LOGIN_INFO = '/GET_LOGIN_INFO';
    Const.SET_LOGIN_INFO = '/SET_LOGIN_INFO';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/userOperation/provider/lib/const.cls.ts
// module id = null
// module chunks = 